export const checkSentryUserPreference = (dataLayer: any) => {
	if (!Array.isArray(dataLayer) || dataLayer.length === 0) {
		return true;
	}
	const sentryObj = dataLayer?.find((item: any) => Object.prototype.hasOwnProperty.call(item, "Sentry"))?.Sentry;
	return sentryObj ?? true;
};
